export const ICON_VERSION_HISTORY = 'icon-history';

export interface SaveStatusVersionHistorySwapProps {
  savedIcon: string;
  savedLabel: string;
  onOpenVersionHistory: () => void;
}
